import { computed } from 'vue'

import type { UseEntityQueryOptions } from '@/support/query/UseEntityQueryOptions.types'

import { useConfigurationQuery } from '@/domains/configuration/composables/use-configuration-query/useConfigurationQuery'

export const useQuickUpdateConfig = (options: UseEntityQueryOptions = {}) => {
  const { get, isLoading, isSuccess } = useConfigurationQuery(options)

  const defaultLocationId = computed(() => get<string | null>('inventory.quick_update.default_location_id', null))

  return {
    defaultLocationId,
    isLoading,
    isSuccess
  }
}
